// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"165":"17aad623","233":"a06558e8","336":"c8906dfa","346":"d867247a","527":"85b7b357","615":"03dc1909","632":"07d4034f","980":"7e0fb7d4","985":"7c0158ca"}[chunkId] + ".js";
};